import type { Coupon, MetaShortDTO, Restaurant } from 'shared/types'
import type { Action } from './actions'

export type State = {
    metaData: ?MetaShortDTO,
    restaurant: ?Restaurant,
    coupons: Array<Coupon>,
    dataLoaded?: boolean,
    couponsLoaded?: boolean,
    sendMailSuccess?: boolean,
    sendMailError?: string,
    error?: any,
    couponsError?: string,
    networkError?: any
}

const initialState: State = {
    metaData: null,
    restaurant: null,
    coupons: []
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_RESTAURANT_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true
            }
        case 'PAGE_RESTAURANT_COUPONS':
            return {
                ...state,
                ...action,
                couponsLoaded: true,
                couponsError: undefined
            }
        case 'PAGE_RESTAURANT_SEND_MAIL_SUCCESS':
            return {
                ...state,
                sendMailSuccess: true,
                sendMailError: undefined
            }
        case 'PAGE_RESTAURANT_SEND_MAIL_ERROR':
            return {
                ...state,
                sendMailError: action.sendMailError,
                sendMailSuccess: false
            }
        case 'PAGE_API_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'RESTAURANT_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'RESTAURANT_COUPONS_ERROR':
            return {
                ...state,
                couponsLoaded: true,
                ...action
            }
        case 'RESTAURANT_RESET':
            return initialState
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
